import { render, staticRenderFns } from "./list-widget.vue?vue&type=template&id=2fa16670&"
import script from "./list-widget.vue?vue&type=script&lang=ts&"
export * from "./list-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports